export default __webpack_public_path__ + "static/media/bg-4.c5eb3ed8.webp";